import React, { FC } from 'react';
import classNames from 'classnames';
import PhoneInput from 'react-phone-input-2';
import ValidationMessage from '../ValidationMessage';
import 'react-phone-input-2/lib/style.css';
import './TelField.scss';
import { FieldProps } from '../models';

const TelField: FC<FieldProps> = ({ label, id, isRequired, errorMessage, ts, ...other }) => (
  <div className={classNames('phone-field form-field', { 'phone-field--error': !!errorMessage })}>
    {label && (
      <label
        htmlFor={id}
        className={classNames('form-field__label', { 'form-field__label--error': isRequired })}
      >
        {ts[label]}
      </label>
    )}
    <PhoneInput inputClass="phone-input" {...other} placeholder={ts.phonePlaceholder} />
    {errorMessage && <ValidationMessage errorMessage={ts[errorMessage]} />}
  </div>
);

export default TelField;
